export default __webpack_public_path__ + "static/media/IconClose.5a2331e3.svg";